//价格"分"转化成"元"
export function formatPrice(cent, priceStyle) {
  let str = '--';

  if (typeof cent === 'number') {
    str = (cent / 100.0).toFixed(2);

    if (priceStyle === 'short') {
      str = str.replace(/(\.\d)0$/, (m, m1) => (m1 === '.0' ? '' : m1));
    }
  }

  return str;
}

// 时间戳转换
export function formatDateTime(sec, timeStyle = 'long') {
  let str = '';
  if (!sec) {
    return str;
  }
  const pad = function(number) {
    return (number < 10 ? '0' : '') + number;
  };
  let date = new Date(sec * 1000);

  /* 2017-08-25 10:55:00 */
  if (timeStyle === 'long') {
    str =
      pad(date.getFullYear()) +
      '-' +
      pad(date.getMonth() + 1) +
      '-' +
      pad(date.getDate()) +
      ' ' +
      pad(date.getHours()) +
      ':' +
      pad(date.getMinutes()) +
      ':' +
      pad(date.getSeconds());
  } else if (timeStyle === 'medium') {
    /* 2017-08-25 10:55 */
    str =
      pad(date.getFullYear()) +
      '-' +
      pad(date.getMonth() + 1) +
      '-' +
      pad(date.getDate()) +
      ' ' +
      pad(date.getHours()) +
      ':' +
      pad(date.getMinutes());
  } else if (timeStyle === 'short') {
    /* 2017-08-25 */
    str =
      pad(date.getFullYear()) +
      '-' +
      pad(date.getMonth() + 1) +
      '-' +
      pad(date.getDate());
  } else if (timeStyle === 'ymdOrmd') {
    /* 上一年的加上年份：2017-08-25，今年的只显示月日：08-25 */
    const currentYear = new Date().getFullYear();
    const receiveYear = date.getFullYear();
    const year = currentYear !== receiveYear ? pad(receiveYear) + '-' : '';
    str = year + pad(date.getMonth() + 1) + '-' + pad(date.getDate());
  } else if (timeStyle === 'ym') {
    /* 2019年1月 */
    str = pad(date.getFullYear()) + '年' + pad(date.getMonth() + 1) + '月';
  } else if (timeStyle === 'ymDash') {
    /* 2019-01 */
    str = pad(date.getFullYear()) + '-' + pad(date.getMonth() + 1);
  } else if (timeStyle === 'md') {
    /* 08-25 */
    str = pad(date.getMonth() + 1) + '-' + pad(date.getDate());
  } else if (timeStyle === 'hm') {
    /* 10:55 */
    str = pad(date.getHours()) + ':' + pad(date.getMinutes());
  } else if (timeStyle === 'hms') {
    /* 10:55:00 */
    str =
      pad(date.getHours()) +
      ':' +
      pad(date.getMinutes()) +
      ':' +
      pad(date.getSeconds());
  } else if (timeStyle === 'localeMdms') {
    str =
      date.getMonth() +
      1 +
      '月' +
      date.getDate() +
      '日 ' +
      pad(date.getHours()) +
      ':' +
      pad(date.getMinutes());
  } else if (timeStyle === 'localeYmd') {
    /* 2017年08月25日 */
    str =
      pad(date.getFullYear()) +
      '年' +
      pad(date.getMonth() + 1) +
      '月' +
      pad(date.getDate()) +
      '日';
  } else if (timeStyle === 'localeYmd_hm') {
    /* 2017年08月25日 10:55 */
    const currentYear = new Date().getFullYear();
    str =
      `${currentYear !== date.getFullYear() ? pad(date.getFullYear()) +
      '年' : ''}` +
      pad(date.getMonth() + 1) +
      '月' +
      pad(date.getDate()) +
      '日' +
      ' ' +
      pad(date.getHours()) + ':' + pad(date.getMinutes());
  }

  return str;
}

//手机号打码
export function formatMobileString(str = '') {
  const length = str.length;
  const len = Math.ceil(length / 3.0);
  const loc = Math.floor((length - len) / 2.0);

  let stars = '';
  for (let idx = 0; idx < len; idx++) {
    stars += '*';
  }

  return str.slice(0, loc) + stars + str.slice(loc + len);
}

// 会员等级转换
export function formatUserLevel(level) {
  let dict = {
    '1': '钻石会员',
    '5': '白金会员',
    '10': '金卡会员',
    '15': 'CB会员',
    '20': '普通用户',
  };

  return dict[level] || '';
}

//顾问类型 转换
export function formatCounselorTag(tag) {
  const dict = {
    '0': '护肤顾问',
    '1': '减重顾问',
  };
  return dict[tag] || '';
}

export function formatStudioType(type, typeTag) {
  if (type === 1) {
    return '官方顾问';
  } else if (type === 0) {
    return (typeTag || []).map(tag => formatCounselorTag(tag)).join('、');
  }

  return '';
}

// 重量转换
export function formatWeight(gram) {
  let str;

  if (gram <= 0) {
    str = '--';
  } else if (gram < 1000) {
    str = gram + 'g';
  } else {
    str = (gram * 0.001).toFixed(1);
    if (str.slice(-2) === '.0') {
      str = str.slice(0, -2);
    }
    str += 'kg';
  }
  return str;
}

export function formatOrderStatus(status) {
  const dict = {
    '-31': '退款失败',
    '-11': '已取消',
    '10': '待付款',
    '21': '已付款',
    '22': '配货中',
    '23': '运输中',
    '24': '派送中',
    '25': '已签收',
    '26': '已拒收',
    '27': '已确认收货',
    '28': '由京东发货',
    '32': '退款中',
    '33': '已退款',
    '41': '清关中',
  };

  return dict[status] || '';
}

export function formatOrderPayType(type) {
  const dict = {
    '1': '余额支付',
    '2': '微信支付',
  };

  return dict[type] || '';
}

export function formatLevelJoinRule(levelJoin) {
  let allLevels = [1, 5, 10, 15, 20];
  const levelJoinDict = allLevels.reduce((dict, level) => {
    if (levelJoin.indexOf(level) === -1) {
      dict[level] = false;
    } else {
      dict[level] = true;
    }
    return dict;
  }, {});

  let str = '';
  if (
    levelJoinDict[1] &&
    levelJoinDict[5] &&
    levelJoinDict[10] &&
    levelJoinDict[15] &&
    levelJoinDict[20]
  ) {
    str = '所有用户均可';
  } else if (
    levelJoinDict[1] &&
    levelJoinDict[5] &&
    levelJoinDict[10] &&
    levelJoinDict[15]
  ) {
    str = '仅限会员';
  } else if (levelJoinDict[1] && levelJoinDict[5] && levelJoinDict[10]) {
    str = '仅限高级会员';
  } else if (!levelJoinDict[20]) {
    if (!levelJoinDict[15]) {
      let mArr = [];
      levelJoinDict[10] && mArr.push('金卡');
      levelJoinDict[5] && mArr.push('白金');
      levelJoinDict[1] && mArr.push('钻石');
      str = `仅限${mArr.join('/')}会员`;
    } else {
      str = '仅限CB会员用户';
    }
  } else {
    str = '仅限非会员用户';
  }

  return str;
}

export function formatProductDisableBuyMsg(status, stock) {
  let disabledMessage = '';
  if (status === 0) {
    disabledMessage = '未上架';
  } else if (status === 2) {
    disabledMessage = '已下架';
  } else if (status === 3) {
    disabledMessage = '即将上架';
  } else if (stock === 0) {
    disabledMessage = '已抢光';
  }
  return disabledMessage;
}

export function formatterMonth(time) {
  let date = new Date();
  if (time) {
    date = new Date(time);
  }
  const st1 = date.setDate(1);
  const st2 = new Date(st1).setHours(0);
  const st3 = new Date(st2).setMinutes(0);
  const startTime = Math.round(new Date(st3).setSeconds(0) / 1000);
  let currentMonth = date.getMonth();
  const nextMonth = ++currentMonth;
  const nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
  const oneDay = 1000 * 60 * 60 * 24;
  const et1 = new Date(nextMonthFirstDay - oneDay).setHours(23);
  const et2 = new Date(et1).setMinutes(59);
  const endTime = Math.round(new Date(et2).setSeconds(59) / 1000);
  return { startTime, endTime };
}

// 数字切分整数和小数（比如金额）
export function formatNumSep(num = '0.00') {
  if (typeof num !== 'string') {
    return null;
  }

  const num_sep = num.split('.');
  const integer = num_sep[0];
  const decimal = num_sep[1];

  return [integer, decimal];
}

export function formatFinalPayMoney(money, level = 20, mjLevelDiscount = mjLevelDiscountDefault) {
  if (!money) {
    return { discount: 0, money: 0 };
  }

  const number = Math.floor(money / 10000);
  money = money - mjLevelDiscount[level] * number;

  return { discount: number * mjLevelDiscount[level], money, discountText: `每满100减${mjLevelDiscount[level] / 100}` };
}

// 满减日常活动，等级对应的折扣
export const mjLevelDiscountDefault = {
  '1': 0,
  '5': 0,
  '10': 0,
  '15': 0,
  '20': 0,
}
